
<template>
  <div>
    <card-loading-transparent loadingText="Carregando cliente" v-if="loading_client"></card-loading-transparent>
    <v-radio-group v-model="order.shipping.address_id" column :loading="loading_client" :rules="required" v-if="addresses.length != 0">
      <v-radio v-for="(addr, idx) in addresses" :key="idx" :value="addr.attributes.id"
        :label="`${addr.attributes.addr || addr.attributes.street}, ${addr.attributes.number},CEP ${addr.attributes.zip}, ${addr.attributes.city} - ${addr.attributes.state}`" 
      ></v-radio>
    </v-radio-group>

    <div v-if="addresses.length == 0 && !loading_client && !order.without_client" class="pt-3">
      <v-alert type="info" icon="mdi-alert" :value="true">
        Endereço não cadastrado.
      </v-alert>
    </div>
    <div v-if="addresses.length == 0 && !loading_client && order.without_client" class="pt-3">
      <v-alert type="info" icon="mdi-account-alert" :value="true">
        Pedido sem cliente.
      </v-alert>
    </div>
  </div>
</template>

<script>
import Api from '@/api/index'
import validations from '@/mixins/validations'

export default {
  name: 'AddressSelect',
  props: {
    order: {
      type: Object,
    },
  },
  mixins: [ validations ],
  data() {
    return {
      loading_client: false,
      addresses: [],
    }
  },
  mounted () {
    this.showClient();
  },
  methods: {
    showClient(){
      let id = this.order.client_id
      if( id ){
        this.loading_client = true
        let params = {short: true}
        Api.Client.show({id, params}).then(r => {
          this.addresses = r.data.data.attributes.shipping_address.data
        }).catch(err=>{
          console.log(err);
        }).finally(()=>{
          this.loading_client = false
        })
      }else{
        this.addresses = []
      }

    },
  },
  watch: {
    'order.client_id'() {
      this.showClient()
    },

    'order.shipping.address_id' (nv) {
      if (nv) {
        let {addr, number, zip, city, state, complement, neighborhood} = this.addresses.find(a => Number(a.id) == Number(nv)).attributes
        this.order.shipping.whole_address = `${addr}, Nº ${number} ${complement? ', '+complement : ''}, bairro ${neighborhood} ,CEP ${zip}, ${city} - ${state}`
      }
    }
  },
}
</script>